import * as i4 from '@angular/common';
import { CommonModule, DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { Directive, Injectable, InjectionToken, inject, ViewChild, ViewEncapsulation, ChangeDetectionStrategy, Component, NgModule, createComponent, Inject } from '@angular/core';
import { uuid, appendChild } from '@primeuix/utils';
import { TranslationKeys, SharedModule } from 'primeng/api';
import { BaseComponent, PARENT_INSTANCE } from 'primeng/basecomponent';
import * as i3 from 'primeng/bind';
import { Bind, BindModule } from 'primeng/bind';
import { DialogStyle, Dialog } from 'primeng/dialog';
import { Subject } from 'rxjs';
const _c0 = () => ({
  severity: "secondary",
  variant: "text",
  rounded: true
});
function DynamicDialog_1_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DynamicDialog_1_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DynamicDialog_1_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngComponentOutlet", ctx_r0.headerTemplate);
  }
}
function DynamicDialog_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DynamicDialog_1_ng_template_0_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
  }
}
function DynamicDialog_2_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DynamicDialog_2_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DynamicDialog_2_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngComponentOutlet", ctx_r0.contentTemplate);
  }
}
function DynamicDialog_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DynamicDialog_2_ng_template_0_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
  }
}
function DynamicDialog_3_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DynamicDialog_3_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DynamicDialog_3_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngComponentOutlet", ctx_r0.footerTemplate);
  }
}
function DynamicDialog_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DynamicDialog_3_ng_template_0_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
  }
}
function DynamicDialog_4_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DynamicDialog_4_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DynamicDialog_4_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngComponentOutlet", ctx_r0.closeIconTemplate);
  }
}
function DynamicDialog_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DynamicDialog_4_ng_template_0_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
  }
}
function DynamicDialog_5_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DynamicDialog_5_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DynamicDialog_5_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngComponentOutlet", ctx_r0.maximizeIconTemplate);
  }
}
function DynamicDialog_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DynamicDialog_5_ng_template_0_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
  }
}
function DynamicDialog_6_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DynamicDialog_6_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DynamicDialog_6_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngComponentOutlet", ctx_r0.minimizeIconTemplate);
  }
}
function DynamicDialog_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DynamicDialog_6_ng_template_0_Template, 1, 1, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
  }
}
function DynamicDialog_7_ng_template_0_Template(rf, ctx) {}
function DynamicDialog_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DynamicDialog_7_ng_template_0_Template, 0, 0, "ng-template", 9);
  }
}
function DynamicDialog_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.ddconfig.footer);
  }
}
let DynamicDialogContent = /*#__PURE__*/(() => {
  class DynamicDialogContent {
    viewContainerRef;
    constructor(viewContainerRef) {
      this.viewContainerRef = viewContainerRef;
    }
    static ɵfac = function DynamicDialogContent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DynamicDialogContent)(i0.ɵɵdirectiveInject(i0.ViewContainerRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: DynamicDialogContent,
      selectors: [["", "pDynamicDialogContent", ""]]
    });
  }
  return DynamicDialogContent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicDialogStyle = /*#__PURE__*/(() => {
  class DynamicDialogStyle extends DialogStyle {
    name = 'dialog';
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDynamicDialogStyle_BaseFactory;
      return function DynamicDialogStyle_Factory(__ngFactoryType__) {
        return (ɵDynamicDialogStyle_BaseFactory || (ɵDynamicDialogStyle_BaseFactory = i0.ɵɵgetInheritedFactory(DynamicDialogStyle)))(__ngFactoryType__ || DynamicDialogStyle);
      };
    })();
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: DynamicDialogStyle,
      factory: DynamicDialogStyle.ɵfac
    });
  }
  return DynamicDialogStyle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 *
 * DynamicDialog is a container to display content in an overlay window.
 *
 * [Live Demo](https://www.primeng.org/dynamicdialog)
 *
 * @module dynamicdialogstyle
 *
 */
var DynamicDialogClasses = /*#__PURE__*/function (DynamicDialogClasses) {
  /**
   * Class name of the mask element
   */
  DynamicDialogClasses["mask"] = "p-dialog-mask";
  /**
   * Class name of the root element
   */
  DynamicDialogClasses["root"] = "p-dialog";
  /**
   * Class name of the header element
   */
  DynamicDialogClasses["header"] = "p-dialog-header";
  /**
   * Class name of the title element
   */
  DynamicDialogClasses["title"] = "p-dialog-title";
  /**
   * Class name of the header actions element
   */
  DynamicDialogClasses["headerActions"] = "p-dialog-header-actions";
  /**
   * Class name of the maximize button element
   */
  DynamicDialogClasses["pcMaximizeButton"] = "p-dialog-maximize-button";
  /**
   * Class name of the close button element
   */
  DynamicDialogClasses["pcCloseButton"] = "p-dialog-close-button";
  /**
   * Class name of the content element
   */
  DynamicDialogClasses["content"] = "p-dialog-content";
  /**
   * Class name of the footer element
   */
  DynamicDialogClasses["footer"] = "p-dialog-footer";
  return DynamicDialogClasses;
}(DynamicDialogClasses || {});
/**
 * Dialogs can be created dynamically with any component as the content using a DialogService.
 * @group Components
 */
class DynamicDialogConfig {
  /**
   * An object to pass to the component loaded inside the Dialog.
   * @group Props
   */
  data;
  /**
   * An object to pass to the component loaded inside the Dialog.
   * @group Props
   */
  inputValues;
  /**
   * Header text of the dialog.
   * @group Props
   */
  header;
  /**
   * Identifies the element (or elements) that labels the element it is applied to.
   * @group Props
   */
  ariaLabelledBy;
  /**
   * Footer text of the dialog.
   * @group Props
   */
  footer;
  /**
   * Width of the dialog.
   * @group Props
   */
  width;
  /**
   * Height of the dialog.
   * @group Props
   */
  height;
  /**
   * Specifies if pressing escape key should hide the dialog.
   * @group Props
   */
  closeOnEscape = false;
  /**
   * Specifies if autofocus should happen on show.
   * @group Props
   */
  focusOnShow = true;
  /**
   * When enabled, can only focus on elements inside the dialog.
   * @group Props
   */
  focusTrap = true;
  /**
   * Base zIndex value to use in layering.
   * @group Props
   */
  baseZIndex;
  /**
   * Whether to re-enforce layering through applying zIndex.
   * @group Props
   */
  autoZIndex = false;
  /**
   * Specifies if clicking the modal background should hide the dialog.
   * @group Props
   */
  dismissableMask = false;
  /**
   * Inline style of the component.
   * @group Props
   */
  rtl = false;
  /**
   * Inline style of the component.
   * @group Props
   */
  style;
  /**
   * Inline style of the content.
   * @group Props
   */
  contentStyle;
  /**
   * Style class of the component.
   * @group Props
   */
  styleClass;
  /**
   * Transition options of the animation.
   * @group Props
   */
  transitionOptions;
  /**
   * Adds a close icon to the header to hide the dialog.
   * @group Props
   */
  closable = false;
  /**
   * Whether to show the header or not.
   * @group Props
   */
  showHeader = false;
  /**
   * Defines if background should be blocked when dialog is displayed.
   * @group Props
   */
  modal = false;
  /**
   * Style class of the mask.
   * @group Props
   */
  maskStyleClass;
  /**
   * Enables resizing of the content.
   * @group Props
   */
  resizable = false;
  /**
   * Enables dragging to change the position using header.
   * @group Props
   */
  draggable = false;
  /**
   * Keeps dialog in the viewport.
   * @group Props
   */
  keepInViewport = false;
  /**
   * Minimum value for the left coordinate of dialog in dragging.
   * @group Props
   */
  minX;
  /**
   * Minimum value for the top coordinate of dialog in dragging.
   * @group Props
   */
  minY;
  /**
   * Whether the dialog can be displayed full screen.
   * @group Props
   */
  maximizable = false;
  /**
   * Name of the maximize icon.
   * @group Props
   */
  maximizeIcon;
  /**
   * Name of the minimize icon.
   * @group Props
   */
  minimizeIcon;
  /**
   * Position of the dialog, options are "center", "top", "bottom", "left", "right", "topleft", "topright", "bottomleft" or "bottomright".
   * @group Props
   */
  position;
  /**
   * Defines a string that labels the close button for accessibility.
   * @group Props
   */
  closeAriaLabel;
  /**
   * Target element to attach the overlay, valid values are "body" or a local ng-template variable of another element (note: use binding with brackets for template variables, e.g. [appendTo]="mydiv" for a div element having #mydiv as variable name).
   * @group Props
   */
  appendTo;
  /**
   * A boolean to determine if it can be duplicate.
   * @group Props
   */
  duplicate = false;
  /**
   * Object literal to define widths per screen size.
   * @group Props
   */
  breakpoints;
  /**
   * Dialog templates.
   * @group Props
   */
  templates;
  /**
   * Used to pass attributes to DOM elements inside the Dialog component.
   * @group Props
   */
  pt;
  /**
   * Indicates whether the component should be rendered without styles.
   * @group Props
   */
  unstyled;
}

/**
 * Dynamic Dialog instance.
 * @group Components
 */
class DynamicDialogRef {
  constructor() {}
  /**
   * Closes dialog.
   * @group Method
   */
  close(result) {
    this._onClose.next(result);
    setTimeout(() => {
      this._onClose.complete();
    }, 1000);
  }
  /**
   * Destroys the dialog instance.
   * @group Method
   */
  destroy() {
    this._onDestroy.next(null);
  }
  /**
   * Callback to invoke on drag start.
   * @param {MouseEvent} event - Mouse event.
   * @group Method
   */
  dragStart(event) {
    this._onDragStart.next(event);
  }
  /**
   * Callback to invoke on drag end.
   * @param {MouseEvent} event - Mouse event.
   * @group Method
   */
  dragEnd(event) {
    this._onDragEnd.next(event);
  }
  /**
   * Callback to invoke on resize start.
   * @param {MouseEvent} event - Mouse event.
   * @group Method
   */
  resizeInit(event) {
    this._onResizeInit.next(event);
  }
  /**
   * Callback to invoke on resize start.
   * @param {MouseEvent} event - Mouse event.
   * @group Method
   */
  resizeEnd(event) {
    this._onResizeEnd.next(event);
  }
  /**
   * Callback to invoke on dialog is maximized.
   * @param {*} value - Size value.
   * @group Method
   */
  maximize(value) {
    this._onMaximize.next(value);
  }
  _onClose = new Subject();
  /**
   * Event triggered on dialog is closed.
   * @group Events
   */
  onClose = this._onClose.asObservable();
  _onDestroy = new Subject();
  /**
   * Event triggered on dialog instance is destroyed.
   * @group Events
   */
  onDestroy = this._onDestroy.asObservable();
  _onDragStart = new Subject();
  /**
   * Event triggered on drag start.
   * @param {MouseEvent} event - Mouse event.
   * @group Events
   */
  onDragStart = this._onDragStart.asObservable();
  _onDragEnd = new Subject();
  /**
   * Event triggered on drag end.
   * @param {MouseEvent} event - Mouse event.
   * @group Events
   */
  onDragEnd = this._onDragEnd.asObservable();
  _onResizeInit = new Subject();
  /**
   * Event triggered on resize start.
   * @param {MouseEvent} event - Mouse event.
   * @group Events
   */
  onResizeInit = this._onResizeInit.asObservable();
  _onResizeEnd = new Subject();
  /**
   * Event triggered on resize end.
   * @param {MouseEvent} event - Mouse event.
   * @group Events
   */
  onResizeEnd = this._onResizeEnd.asObservable();
  _onMaximize = new Subject();
  /**
   * Event triggered on dialog is maximized.
   * @param {*} value - Size value.
   * @group Events
   */
  onMaximize = this._onMaximize.asObservable();
  /**
   * Event triggered on child component load.
   * @param {*} value - Chi.
   * @group Events
   */
  onChildComponentLoaded = new Subject();
}
const DYNAMIC_DIALOG_INSTANCE = /*#__PURE__*/new InjectionToken('DYNAMIC_DIALOG_INSTANCE');
let DynamicDialog = /*#__PURE__*/(() => {
  class DynamicDialog extends BaseComponent {
    ddconfig;
    dialogRef;
    componentName = 'Dialog';
    _componentStyle = inject(DynamicDialogStyle);
    $pcDynamicDialog = inject(DYNAMIC_DIALOG_INSTANCE, {
      optional: true,
      skipSelf: true
    }) ?? undefined;
    bindDirectiveInstance = inject(Bind, {
      self: true
    });
    onAfterViewChecked() {
      this.bindDirectiveInstance.setAttrs(this.ptms(['host', 'root']));
    }
    visible = true;
    componentRef;
    id = uuid('pn_id_');
    insertionPoint;
    dialog;
    childComponentType;
    inputValues;
    get minX() {
      return this.ddconfig.minX ? this.ddconfig.minX : 0;
    }
    get minY() {
      return this.ddconfig.minY ? this.ddconfig.minY : 0;
    }
    get keepInViewport() {
      return this.ddconfig.keepInViewport;
    }
    get maximizable() {
      return this.ddconfig.maximizable;
    }
    get maximizeIcon() {
      return this.ddconfig.maximizeIcon;
    }
    get minimizeIcon() {
      return this.ddconfig.minimizeIcon;
    }
    get closable() {
      return this.ddconfig.closable;
    }
    get position() {
      return this.ddconfig.position;
    }
    get defaultCloseAriaLabel() {
      return this.config.getTranslation(TranslationKeys.ARIA)['close'];
    }
    get breakpoints() {
      return this.ddconfig.breakpoints;
    }
    get footerTemplate() {
      return this.ddconfig?.templates?.footer;
    }
    get headerTemplate() {
      return this.ddconfig?.templates?.header;
    }
    get contentTemplate() {
      return this.ddconfig?.templates?.content;
    }
    get minimizeIconTemplate() {
      return this.ddconfig?.templates?.minimizeicon;
    }
    get maximizeIconTemplate() {
      return this.ddconfig?.templates?.maximizeicon;
    }
    get closeIconTemplate() {
      return this.ddconfig?.templates?.closeicon;
    }
    get dialogStyle() {
      return {
        ...(this.ddconfig?.style || {}),
        ...(this.ddconfig?.width && {
          width: this.ddconfig.width
        }),
        ...(this.ddconfig?.height && {
          height: this.ddconfig.height
        })
      };
    }
    get header() {
      return this.ddconfig.header;
    }
    get data() {
      return this.ddconfig.data;
    }
    get dialogId() {
      return this.$attrSelector;
    }
    get isUnstyled() {
      return this.ddconfig.unstyled || this.$unstyled();
    }
    maximized;
    dragging;
    resizing;
    ariaLabelledBy;
    _style = {};
    styleElement;
    lastPageX;
    lastPageY;
    contentViewChild;
    footerViewChild;
    headerViewChild;
    maskViewChild;
    maskClickListener;
    documentDragListener;
    documentDragEndListener;
    documentResizeListener;
    documentResizeEndListener;
    documentEscapeListener;
    constructor(ddconfig, dialogRef) {
      super();
      this.ddconfig = ddconfig;
      this.dialogRef = dialogRef;
    }
    onVisibleChange(visible) {
      if (!visible) {
        this.dialogRef.close();
      }
    }
    onAfterViewInit() {
      this.loadChildComponent(this.childComponentType);
      this.ariaLabelledBy = this.getAriaLabelledBy();
      this.cd.detectChanges();
    }
    getAriaLabelledBy() {
      const {
        header,
        showHeader
      } = this.ddconfig;
      if (header === null || showHeader === false) {
        return null;
      }
      return uuid('pn_id_') + '_header';
    }
    loadChildComponent(componentType) {
      let viewContainerRef = this.insertionPoint?.viewContainerRef;
      viewContainerRef?.clear();
      this.componentRef = viewContainerRef?.createComponent(componentType);
      if (this.inputValues && this.componentRef) {
        Object.entries(this.inputValues).forEach(([key, value]) => {
          this.componentRef.setInput(key, value);
        });
      }
      this.dialogRef.onChildComponentLoaded.next(this.componentRef.instance);
    }
    onDialogHide(event) {
      this.dialogRef.destroy();
    }
    onDialogMaximize(event) {
      this.maximized = event.maximized;
      this.dialogRef.maximize(event);
    }
    onDialogResizeInit(event) {
      this.resizing = true;
      this.dialogRef.resizeInit(event);
    }
    onDialogResizeEnd(event) {
      this.resizing = false;
      this.dialogRef.resizeEnd(event);
    }
    onDialogDragEnd(event) {
      this.dragging = false;
      this.dialogRef.dragEnd(event);
    }
    close() {
      this.visible = false;
      this.cd.markForCheck();
    }
    hide() {
      if (this.dialogRef) {
        this.dialogRef.close();
      }
    }
    get _parent() {
      const domElements = Array.from(this.document.getElementsByClassName('p-dialog'));
      if (domElements.length > 1) {
        return domElements.pop();
      }
    }
    get parentContent() {
      const domElements = Array.from(this.document.getElementsByClassName('p-dialog'));
      if (domElements.length > 0) {
        const contentElements = domElements[domElements.length - 1].querySelector('.p-dialog-content');
        if (contentElements) return Array.isArray(contentElements) ? contentElements[0] : contentElements;
      }
    }
    container;
    wrapper;
    unbindGlobalListeners() {
      this.unbindDocumentEscapeListener();
      this.unbindDocumentResizeListeners();
      this.unbindDocumentDragListener();
      this.unbindDocumentDragEndListener();
    }
    onAnimationStart(event) {
      if (event.toState === 'visible') {
        // If parent dialog exists, unbind its listeners first
        if (this._parent) {
          this.unbindGlobalListeners();
        }
        if (this.ddconfig.modal) {
          this.enableModality();
        }
      }
    }
    onAnimationEnd(event) {
      if (event.toState === 'void') {
        this.onContainerDestroy();
        this.dialogRef.destroy();
      }
    }
    onContainerDestroy() {
      this.unbindGlobalListeners();
      if (this.ddconfig.modal) {
        this.disableModality();
      }
      this.container = null;
    }
    bindDocumentDragListener() {
      if (!this.documentDragListener) {
        this.documentDragListener = this.renderer.listen(this.document.defaultView, 'mousemove', event => {
          this.onDrag(event);
        });
      }
    }
    bindDocumentDragEndListener() {
      if (!this.documentDragEndListener) {
        this.documentDragEndListener = this.renderer.listen(this.document.defaultView, 'mouseup', event => {
          this.endDrag(event);
        });
      }
    }
    unbindDocumentDragEndListener() {
      if (this.documentDragEndListener) {
        this.documentDragEndListener();
        this.documentDragEndListener = null;
      }
    }
    unbindDocumentDragListener() {
      if (this.documentDragListener) {
        this.documentDragListener();
        this.documentDragListener = null;
      }
    }
    initDrag(event) {
      // Don't initialize drag when clicking on header icons
      if (event.target instanceof HTMLElement) {
        const target = event.target;
        if (target.closest('.p-dialog-header-icon') || target.closest('.p-dialog-header-icons')) {
          return;
        }
      }
      this.dragging = true;
      this.lastPageX = event.pageX;
      this.lastPageY = event.pageY;
      this.dialogRef.dragStart(event);
      this.bindDocumentDragListener();
      this.bindDocumentDragEndListener();
      // Handled by Dialog component
    }
    onDrag(event) {
      if (this.dragging) {
        this.lastPageX = event.pageX;
        this.lastPageY = event.pageY;
        if (this.ddconfig.keepInViewport && this.container) {
          this.container.style.position = 'fixed';
        }
      }
    }
    endDrag(event) {
      if (this.dragging) {
        this.dragging = false;
        this.dialogRef.dragEnd(event);
        this.cd.detectChanges();
      }
    }
    resetPosition() {
      if (this.container) {
        this.container.style.position = '';
        this.container.style.left = '';
        this.container.style.top = '';
        this.container.style.margin = '';
      }
    }
    bindDocumentResizeListeners() {
      if (!this.documentResizeListener) {
        this.documentResizeListener = this.renderer.listen(this.document.defaultView, 'mousemove', event => {
          this.onResize(event);
        });
      }
      if (!this.documentResizeEndListener) {
        this.documentResizeEndListener = this.renderer.listen(this.document.defaultView, 'mouseup', event => {
          this.resizeEnd(event);
        });
      }
    }
    unbindDocumentResizeListeners() {
      if (this.documentResizeListener) {
        this.documentResizeListener();
        this.documentResizeListener = null;
      }
      if (this.documentResizeEndListener) {
        this.documentResizeEndListener();
        this.documentResizeEndListener = null;
      }
    }
    initResize(event) {
      this.resizing = true;
      this.lastPageX = event.pageX;
      this.lastPageY = event.pageY;
      this.dialogRef.resizeInit(event);
    }
    onResize(event) {
      if (this.resizing) {
        this.lastPageX = event.pageX;
        this.lastPageY = event.pageY;
      }
    }
    resizeEnd(event) {
      if (this.resizing) {
        this.resizing = false;
        this.dialogRef.resizeEnd(event);
      }
    }
    maximize() {
      this.maximized = !this.maximized;
      this.dialogRef.maximize({
        maximized: this.maximized
      });
    }
    enableModality() {
      if (this.ddconfig.dismissableMask && this.wrapper) {
        this.maskClickListener = this.renderer.listen(this.wrapper, 'mousedown', event => {
          if (this.wrapper && this.wrapper.isSameNode(event.target)) {
            this.hide();
          }
        });
      }
    }
    disableModality() {
      this.unbindMaskClickListener();
      this.cd.detectChanges();
    }
    unbindMaskClickListener() {
      if (this.maskClickListener) {
        this.maskClickListener();
        this.maskClickListener = null;
      }
    }
    bindDocumentEscapeListener() {
      if (this.ddconfig.closeOnEscape) {
        this.documentEscapeListener = this.renderer.listen(this.document, 'keydown', event => {
          if (event.key === 'Escape' && this.container) {
            this.hide();
          }
        });
      }
    }
    unbindDocumentEscapeListener() {
      if (this.documentEscapeListener) {
        this.documentEscapeListener();
        this.documentEscapeListener = null;
      }
    }
    createStyle() {
      if (!this.styleElement && this.breakpoints) {
        this.styleElement = this.renderer.createElement('style');
        this.styleElement.type = 'text/css';
        this.renderer.appendChild(this.document.head, this.styleElement);
        let innerHTML = '';
        for (let breakpoint in this.breakpoints) {
          innerHTML += `
                    @media screen and (max-width: ${breakpoint}) {
                        .p-dialog[${this.dialogId}] {
                            width: ${this.breakpoints[breakpoint]} !important;
                        }
                    }
                `;
        }
        this.renderer.setProperty(this.styleElement, 'innerHTML', innerHTML);
      }
    }
    destroyStyle() {
      if (this.styleElement) {
        this.renderer.removeChild(this.document.head, this.styleElement);
        this.styleElement = null;
      }
    }
    onDestroy() {
      this.onContainerDestroy();
      if (this.componentRef && typeof this.componentRef.destroy === 'function') {
        this.componentRef.destroy();
      }
      this.destroyStyle();
    }
    static ɵfac = function DynamicDialog_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DynamicDialog)(i0.ɵɵdirectiveInject(DynamicDialogConfig), i0.ɵɵdirectiveInject(DynamicDialogRef));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DynamicDialog,
      selectors: [["p-dynamicDialog"], ["p-dynamicdialog"], ["p-dynamic-dialog"]],
      viewQuery: function DynamicDialog_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(DynamicDialogContent, 5)(Dialog, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.insertionPoint = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dialog = _t.first);
        }
      },
      features: [i0.ɵɵProvidersFeature([DynamicDialogStyle, {
        provide: DYNAMIC_DIALOG_INSTANCE,
        useExisting: DynamicDialog
      }, {
        provide: PARENT_INSTANCE,
        useExisting: DynamicDialog
      }]), i0.ɵɵHostDirectivesFeature([i3.Bind]), i0.ɵɵInheritDefinitionFeature],
      decls: 9,
      vars: 43,
      consts: [["header", ""], ["content", ""], ["footer", ""], ["closeicon", ""], ["maximizeicon", ""], ["minimizeicon", ""], ["appendTo", "self", "hostName", "DynamicDialog", 3, "visibleChange", "onHide", "onMaximize", "onResizeInit", "onResizeEnd", "onDragEnd", "visible", "header", "draggable", "resizable", "contentStyle", "modal", "closeOnEscape", "dismissableMask", "rtl", "closable", "breakpoints", "styleClass", "maskStyleClass", "showHeader", "autoZIndex", "baseZIndex", "minX", "minY", "focusOnShow", "maximizable", "keepInViewport", "focusTrap", "transitionOptions", "closeAriaLabel", "minimizeIcon", "maximizeIcon", "closeButtonProps", "maximizeButtonProps", "position", "pt", "unstyled"], [4, "ngIf"], [4, "ngComponentOutlet"], ["pDynamicDialogContent", ""]],
      template: function DynamicDialog_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "p-dialog", 6);
          i0.ɵɵtwoWayListener("visibleChange", function DynamicDialog_Template_p_dialog_visibleChange_0_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.visible, $event) || (ctx.visible = $event);
            return $event;
          });
          i0.ɵɵlistener("onHide", function DynamicDialog_Template_p_dialog_onHide_0_listener($event) {
            return ctx.onDialogHide($event);
          })("onMaximize", function DynamicDialog_Template_p_dialog_onMaximize_0_listener($event) {
            return ctx.onDialogMaximize($event);
          })("onResizeInit", function DynamicDialog_Template_p_dialog_onResizeInit_0_listener($event) {
            return ctx.onDialogResizeInit($event);
          })("onResizeEnd", function DynamicDialog_Template_p_dialog_onResizeEnd_0_listener($event) {
            return ctx.onDialogResizeEnd($event);
          })("onDragEnd", function DynamicDialog_Template_p_dialog_onDragEnd_0_listener($event) {
            return ctx.onDialogDragEnd($event);
          })("visibleChange", function DynamicDialog_Template_p_dialog_visibleChange_0_listener($event) {
            return ctx.onVisibleChange($event);
          });
          i0.ɵɵtemplate(1, DynamicDialog_1_Template, 2, 0, null, 7)(2, DynamicDialog_2_Template, 2, 0, null, 7)(3, DynamicDialog_3_Template, 2, 0, null, 7)(4, DynamicDialog_4_Template, 2, 0, null, 7)(5, DynamicDialog_5_Template, 2, 0, null, 7)(6, DynamicDialog_6_Template, 2, 0, null, 7)(7, DynamicDialog_7_Template, 1, 0, null, 7)(8, DynamicDialog_div_8_Template, 2, 1, "div", 7);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵstyleMap(ctx.dialogStyle);
          i0.ɵɵtwoWayProperty("visible", ctx.visible);
          i0.ɵɵproperty("header", ctx.ddconfig == null ? null : ctx.ddconfig.header)("draggable", (ctx.ddconfig == null ? null : ctx.ddconfig.draggable) !== false)("resizable", (ctx.ddconfig == null ? null : ctx.ddconfig.resizable) !== false)("contentStyle", ctx.ddconfig == null ? null : ctx.ddconfig.contentStyle)("modal", (ctx.ddconfig == null ? null : ctx.ddconfig.modal) !== false)("closeOnEscape", (ctx.ddconfig == null ? null : ctx.ddconfig.closeOnEscape) !== false)("dismissableMask", ctx.ddconfig == null ? null : ctx.ddconfig.dismissableMask)("rtl", ctx.ddconfig == null ? null : ctx.ddconfig.rtl)("closable", ctx.closable)("breakpoints", ctx.breakpoints)("styleClass", ctx.ddconfig == null ? null : ctx.ddconfig.styleClass)("maskStyleClass", ctx.ddconfig == null ? null : ctx.ddconfig.maskStyleClass)("showHeader", (ctx.ddconfig == null ? null : ctx.ddconfig.showHeader) !== false)("autoZIndex", (ctx.ddconfig == null ? null : ctx.ddconfig.autoZIndex) !== false)("baseZIndex", (ctx.ddconfig == null ? null : ctx.ddconfig.baseZIndex) || 0)("minX", ctx.minX)("minY", ctx.minY)("focusOnShow", (ctx.ddconfig == null ? null : ctx.ddconfig.focusOnShow) !== false)("maximizable", ctx.maximizable)("keepInViewport", ctx.keepInViewport)("focusTrap", (ctx.ddconfig == null ? null : ctx.ddconfig.focusTrap) !== false)("transitionOptions", (ctx.ddconfig == null ? null : ctx.ddconfig.transitionOptions) || "150ms cubic-bezier(0, 0, 0.2, 1)")("closeAriaLabel", (ctx.ddconfig == null ? null : ctx.ddconfig.closeAriaLabel) || ctx.defaultCloseAriaLabel)("minimizeIcon", ctx.minimizeIcon)("maximizeIcon", ctx.maximizeIcon)("closeButtonProps", i0.ɵɵpureFunction0(41, _c0))("maximizeButtonProps", i0.ɵɵpureFunction0(42, _c0))("position", ctx.position)("pt", ctx.ddconfig.pt)("unstyled", ctx.isUnstyled);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.headerTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.contentTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.footerTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.closeIconTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.maximizeIconTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.minimizeIconTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.contentTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.ddconfig.footer && !ctx.footerTemplate);
        }
      },
      dependencies: [CommonModule, i4.NgComponentOutlet, i4.NgIf, SharedModule, DynamicDialogContent, Dialog, BindModule],
      encapsulation: 2
    });
  }
  return DynamicDialog;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicDialogModule = /*#__PURE__*/(() => {
  class DynamicDialogModule {
    static ɵfac = function DynamicDialogModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DynamicDialogModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DynamicDialogModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DynamicDialog, SharedModule, SharedModule]
    });
  }
  return DynamicDialogModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class DynamicDialogInjector {
  _parentInjector;
  _additionalTokens;
  constructor(_parentInjector, _additionalTokens) {
    this._parentInjector = _parentInjector;
    this._additionalTokens = _additionalTokens;
  }
  get(token, notFoundValue, options) {
    const value = this._additionalTokens.get(token);
    if (value) return value;
    return this._parentInjector.get(token, notFoundValue);
  }
}

/**
 * Dynamic Dialog component methods.
 * @group Service
 */
let DialogService = /*#__PURE__*/(() => {
  class DialogService {
    appRef;
    injector;
    document;
    dialogComponentRefMap = new Map();
    constructor(appRef, injector, document) {
      this.appRef = appRef;
      this.injector = injector;
      this.document = document;
    }
    /**
     * Displays the dialog using the dynamic dialog object options.
     * @param {*} componentType - Dynamic component for content template.
     * @param {DynamicDialogConfig} config - DynamicDialog object.
     * @returns {DynamicDialogRef} DynamicDialog instance.
     * @group Method
     */
    open(componentType, config) {
      if (!this.duplicationPermission(componentType, config)) {
        return null;
      }
      const dialogRef = this.appendDialogComponentToBody(config, componentType);
      const componentRefInstance = this.dialogComponentRefMap.get(dialogRef);
      if (componentRefInstance) {
        componentRefInstance.instance.childComponentType = componentType;
        componentRefInstance.instance.inputValues = config.inputValues || {};
      }
      return dialogRef;
    }
    /**
     * Returns the dynamic dialog component instance.
     * @param {DynamicDialogRef} ref - DynamicDialog instance.
     * @group Method
     */
    getInstance(ref) {
      return this.dialogComponentRefMap.get(ref)?.instance;
    }
    appendDialogComponentToBody(config, componentType) {
      const map = new WeakMap();
      map.set(DynamicDialogConfig, config);
      const dialogRef = new DynamicDialogRef();
      map.set(DynamicDialogRef, dialogRef);
      const sub = dialogRef.onClose.subscribe(() => {
        this.dialogComponentRefMap.get(dialogRef)?.instance.close();
      });
      const destroySub = dialogRef.onDestroy.subscribe(() => {
        this.removeDialogComponentFromBody(dialogRef);
        destroySub.unsubscribe();
        sub.unsubscribe();
      });
      const componentRef = createComponent(DynamicDialog, {
        environmentInjector: this.appRef.injector,
        elementInjector: new DynamicDialogInjector(this.injector, map)
      });
      this.appRef.attachView(componentRef.hostView);
      const domElem = componentRef.hostView.rootNodes[0];
      if (!config.appendTo || config.appendTo === 'body') {
        this.document.body.appendChild(domElem);
      } else {
        appendChild(config.appendTo, domElem);
      }
      this.dialogComponentRefMap.set(dialogRef, componentRef);
      return dialogRef;
    }
    removeDialogComponentFromBody(dialogRef) {
      if (!dialogRef || !this.dialogComponentRefMap.has(dialogRef)) {
        return;
      }
      const dialogComponentRef = this.dialogComponentRefMap.get(dialogRef);
      if (dialogComponentRef) {
        this.appRef.detachView(dialogComponentRef.hostView);
        dialogComponentRef.destroy();
        dialogComponentRef.changeDetectorRef.detectChanges();
      }
      this.dialogComponentRefMap.delete(dialogRef);
    }
    duplicationPermission(componentType, config) {
      if (config.duplicate) {
        return true;
      }
      let permission = true;
      for (const [key, value] of this.dialogComponentRefMap) {
        if (value.instance.childComponentType === componentType) {
          permission = false;
          break;
        }
      }
      return permission;
    }
    static ɵfac = function DialogService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DialogService)(i0.ɵɵinject(i0.ApplicationRef), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(DOCUMENT));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: DialogService,
      factory: DialogService.ɵfac
    });
  }
  return DialogService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DialogService, DynamicDialog, DynamicDialogClasses, DynamicDialogConfig, DynamicDialogInjector, DynamicDialogModule, DynamicDialogRef, DynamicDialogStyle };
